import './App.scss';
import React, {useEffect, useRef, useState} from 'react';
import RequestManager from "./services/RequestManager";
import GamesListContainer from "./components/GamesListContainer/GamesListContainer";
import {AUTHORIZATION_DATA, PARTNER_CONFIG_DATA} from "./services/RequestDatas";
import Utils from "./utils/Utils";
import GameStatisticContainer from "./components/GameStatisticContainer/GameStatisticContainer";
import './i18n';
import i18next from "i18next";

export const Context = React.createContext({});

function App() {
  const [availableGames, setAvailableGames] = useState();
  const [activeGameID, setActiveGameID] = useState();
  const [language, setLanguage] = useState('eng');

  const socket = useRef();

  const store = {
    setAvailableGames: {get: availableGames, set: setAvailableGames},
    activeGameID: {get: activeGameID, set: setActiveGameID},
    language: {get: language, set: setLanguage}
  }

  useEffect(() => {
    initAuthorization();
  }, [])

  useEffect(() => {
    changeLanguage();
  }, [language])

  const initAuthorization = () => {
    socket.current = RequestManager.getInstance().webSocket;

    socket.current.onopen = () => {
      socket.current.send(JSON.stringify(AUTHORIZATION_DATA));
      socket.current.addEventListener(RequestManager.AUTHORIZATION_EVENT, getPartnerConfig, {once: true});
    }
  }

  const changeLanguage = () => {
    setLanguage(language);
    i18next.changeLanguage(language, error => error ? console.log('i18n error: ', error) : null).then();
  }

  const getPartnerConfig = () => {
    socket.current.send(JSON.stringify(PARTNER_CONFIG_DATA));
    socket.current.addEventListener(RequestManager.PARTNER_DATA_EVENT,
      response => parsePartnerConfigData(response.detail.data.data.partner), {once: true});
  }

  const parsePartnerConfigData = data => {
    data = data[Utils.firstKey(data)];

    if (data["available_sports"]) {
      setAvailableGames(data["available_sports"]);
    }
  }

  return availableGames
    ? <Context.Provider value={store}>
      <div className='app'>
        {
          activeGameID ? <GameStatisticContainer/> : <GamesListContainer availableGames={availableGames}/>
        }
        <img className="background" src={process.env.PUBLIC_URL + './assets/background.jpg'} alt=""/>
      </div>
    </Context.Provider>
    : <div className='app-loader'/>
}

export default App;
